import { useEffect } from 'react';

import { sendGAEventToDataLayer } from '@nw/shared/utils';

import { ApplicationSectionNameEnums } from '../../constants/ApplicationSectionConstants';
import { useNiatApplicationMachineContext } from '../../context/NiatApplicationMachineProvider';
import { getInstituteDisplayLabel } from '../../utils/EnrollmentFeeUtils';

import {
  CommonUserInfoLabel,
  CommonUserInfoValue,
  UserDetailsAndInfoCardContainer,
  UserDetailsCardContainer,
  UserDetailsFieldGroup,
  UserDetailsFieldRow,
  UserDetailsFieldsStack,
  UserDetailsTwoColumnRow,
  UserInfo,
  UserInfoLabel,
  UserInfoValue
} from '../ProductFeeSection/styledComponent';

export const UserDetailsAndInfoCard = ({
  sectionName = ''
}: {
  sectionName?: string;
}) => {
  const {
    niatApplicationMachineState: {
      context: {
        userGraphQlProfileDetails,
        values,
        initialValues,
        currentSelectedSectionCompletionPercentage,
        latestUserProgramInstituteCourseRow,
        availableProgramInstitutesData
      }
    }
  } = useNiatApplicationMachineContext();

  const isApplicationFeePaymentSuccess = () =>
    currentSelectedSectionCompletionPercentage >= 100;

  const isEnrollmentFeeSection =
    sectionName === ApplicationSectionNameEnums.NIAT_ENROLLMENT_FEE_2026;

  useEffect(() => {
    if (isApplicationFeePaymentSuccess()) {
      sendGAEventToDataLayer({
        event: 'payment_success_page_visit'
      });
    }
  }, [isApplicationFeePaymentSuccess]);

  const getEmailValue = () => {
    return (
      values['EMAIL_ADDRESS'] ||
      initialValues['EMAIL_ADDRESS'] ||
      userGraphQlProfileDetails?.email ||
      ''
    );
  };
  const selectedInstituteName = getInstituteDisplayLabel(
    latestUserProgramInstituteCourseRow?.institute_id,
    availableProgramInstitutesData
  );
  const selectedAccommodationMode =
    latestUserProgramInstituteCourseRow?.accommodation_mode === 'HOSTELER'
      ? 'Hosteler'
      : latestUserProgramInstituteCourseRow?.accommodation_mode ===
          'DAY_SCHOLAR'
        ? 'Day Scholar'
        : '';

  const renderUserDetailCard = () => {
    const emailValue = getEmailValue();

    const userName =
      values['FULL_NAME'] ||
      initialValues?.['FULL_NAME'] ||
      userGraphQlProfileDetails?.name;

    const showEmail =
      sectionName !== ApplicationSectionNameEnums.TAKE_ADMISSION;
    const phoneDisplay = `+91 ${userGraphQlProfileDetails.phone_number}`;

    if (isEnrollmentFeeSection) {
      return (
        <UserDetailsCardContainer>
          <UserDetailsFieldsStack>
            <UserDetailsFieldRow>
              <UserInfoLabel>Applicant Name</UserInfoLabel>
              <UserInfoValue>{userName}</UserInfoValue>
            </UserDetailsFieldRow>

            {selectedInstituteName ? (
              <UserDetailsTwoColumnRow>
                <UserDetailsFieldGroup>
                  <UserInfoLabel>Phone Number</UserInfoLabel>
                  <UserInfoValue>{phoneDisplay}</UserInfoValue>
                </UserDetailsFieldGroup>
                <UserDetailsFieldGroup>
                  <UserInfoLabel>College Assigned</UserInfoLabel>
                  <UserInfoValue className="enrollment-highlight-value">
                    {selectedInstituteName}
                  </UserInfoValue>
                </UserDetailsFieldGroup>
              </UserDetailsTwoColumnRow>
            ) : (
              <UserDetailsFieldRow>
                <UserInfoLabel>Phone Number</UserInfoLabel>
                <UserInfoValue>{phoneDisplay}</UserInfoValue>
              </UserDetailsFieldRow>
            )}

            {showEmail && selectedAccommodationMode ? (
              <UserDetailsTwoColumnRow>
                <UserDetailsFieldGroup>
                  <UserInfoLabel>Email</UserInfoLabel>
                  <UserInfoValue>{emailValue}</UserInfoValue>
                </UserDetailsFieldGroup>
                <UserDetailsFieldGroup>
                  <UserInfoLabel>Accommodation Type</UserInfoLabel>
                  <UserInfoValue className="enrollment-highlight-value">
                    {selectedAccommodationMode}
                  </UserInfoValue>
                </UserDetailsFieldGroup>
              </UserDetailsTwoColumnRow>
            ) : showEmail ? (
              <UserDetailsFieldRow>
                <UserInfoLabel>Email</UserInfoLabel>
                <UserInfoValue>{emailValue}</UserInfoValue>
              </UserDetailsFieldRow>
            ) : selectedAccommodationMode ? (
              <UserDetailsFieldRow>
                <UserInfoLabel>Accommodation Type</UserInfoLabel>
                <UserInfoValue className="enrollment-highlight-value">
                  {selectedAccommodationMode}
                </UserInfoValue>
              </UserDetailsFieldRow>
            ) : null}
          </UserDetailsFieldsStack>
        </UserDetailsCardContainer>
      );
    }

    return (
      <UserDetailsCardContainer>
        <UserInfo>
          <CommonUserInfoLabel>Name : </CommonUserInfoLabel>
          <CommonUserInfoValue> {userName}</CommonUserInfoValue>
        </UserInfo>
        {showEmail ? (
          <UserInfo>
            <CommonUserInfoLabel>Email : </CommonUserInfoLabel>
            <CommonUserInfoValue> {emailValue}</CommonUserInfoValue>
          </UserInfo>
        ) : null}
        <UserInfo>
          <CommonUserInfoLabel>Number : </CommonUserInfoLabel>
          <CommonUserInfoValue>
            +91 {userGraphQlProfileDetails.phone_number}
          </CommonUserInfoValue>
        </UserInfo>
      </UserDetailsCardContainer>
    );
  };

  return (
    <>
      <UserDetailsAndInfoCardContainer className="user-details-and-info-card-container">
        {renderUserDetailCard()}
      </UserDetailsAndInfoCardContainer>
    </>
  );
};
